import React from 'react';
import { css } from '@emotion/core';
import { theme } from '@weave/theme-original';
import { StatusBanner } from 'components/shared';
import { NakedButton, Text } from '@weave/design-system';
import { ReactComponent as StatusWarningIcon } from 'images/status-warning.svg';
import { ReactComponent as RefreshIcon } from 'images/refresh-icon.svg';

interface ExceptionNotedStatusBannerProps {
  exceptionNotedCount: number;
  exceptionNotedMetricNames: string[];
  onRefresh: () => void;
}

export const ExceptionNotedStatusBanner = ({
  exceptionNotedMetricNames,
  onRefresh,
}: ExceptionNotedStatusBannerProps) => {
  return (
    <StatusBanner
      variant="exception_noted"
      icon={<StatusWarningIcon />}
      title={'Check Failed, Exceptions Noted'}
      description={exceptionNotedMetricNames}
      action={
        <NakedButton css={ctaButton} onClick={onRefresh}>
          <RefreshIcon />
          <Text as="span" weight="bold" size="medium">
            Refresh
          </Text>
        </NakedButton>
      }
    />
  );
};

const ctaButton = css`
  font-weight: ${theme.font.weight.bold};
  font-size: ${theme.font.size.medium};
  padding: ${theme.spacing(1)};
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};

  > span {
    color: #146ef5;
  }
`;
